import React, { useRef, useImperativeHandle } from 'react';
import SliderItem from './SliderItem';
import SliderContext from './SliderContext';
import useSlider from '../../../hooks/useSlide';

function Jumbotron (props, ref) {
  const refJumbotron = useRef(null);

  const {
    moveSlide,
    sliderIndex,
    sliderPages,
    bigPaginationIndicator,
    bigPaginationAutoButton,
    totalInViewport
  } = useSlider(refJumbotron, props.data.length, props.data, props.type, 3500, props.onChangeCurrentIndex);

  if (ref != null) {
    useImperativeHandle(ref, () => ({
      mainOnMouseOver: (e) => {
        moveSlide('onmouse_pause');
      },
      mainOnMouseOut: (e) => {
        moveSlide('play');
      }
      // mainOnMouseOut
    }));
  }

  return (
    <SliderContext.Provider value={[]}>
      <div className='event_topswipe_w'>
        <ul className='event_topswipe_list' ref={refJumbotron}>
          {props.data.map((item, index) => {
            const sliderIndexViewStart = (sliderIndex * totalInViewport);
            const sliderIndexViewEnd = sliderIndexViewStart + totalInViewport;
            const isBetween = index >= sliderIndexViewStart && index < sliderIndexViewEnd;
            return (
              <SliderItem
                key={index}
                view={isBetween}
                slide_key={item.id || item.order_no || item.ord_no}
                {...item}
                index={index}
                currentIndex={sliderIndex}
                type='eventtopbox'
                moveSlide={moveSlide}
                imageQuality={100}
              />
            );
          })}
        </ul>

        {props.data.length > 1 && (
          <button className='slide_button_prev' aria-label='이전 콘텐츠 보기' onClick={() => moveSlide('left')} onMouseOver={(e) => moveSlide('onmouse_pause')} onMouseOut={(e) => moveSlide('play')}>
            <span className='sb_inner'>
              {/* 초기시안시에는 네비게시션 텍스트 페이징 체크하기로 해두었어서 일단 주석처리함 */}
              {/* <span className='sb_paging'><i className='sbp_active'>{sliderIndex + 1}</i>/<i className='sbp_all'>{sliderPages}</i></span> */}
              <span className='sb_icon'>
                <svg xmlns='http://www.w3.org/2000/svg' width='10' height='20' viewBox='0 0 12.414 22.828'><path d='M-11109.5-16189.5l-10,10,10,10' transform='translate(11120.5 16190.914)' /></svg>
                <i className='hide'>이전</i>
              </span>
            </span>
          </button>
        )}

        {props.data.length > 1 && (
          <button className='slide_button_next' aria-label='다음 콘텐츠 보기' onClick={() => moveSlide('right')} onMouseOver={(e) => moveSlide('onmouse_pause')} onMouseOut={(e) => moveSlide('play')}>
            <span className='sb_inner'>
              {/* 초기시안시에는 네비게시션 텍스트 페이징 체크하기로 해두었어서 일단 주석처리함 */}
              {/* <span className='sb_paging'><i className='sbp_active'>{sliderIndex + 1}</i>/<i className='sbp_all'>{sliderPages}</i></span> */}
              <span className='sb_icon'>
                <svg xmlns='http://www.w3.org/2000/svg' width='10' height='20' viewBox='0 0 12.414 22.828'><path d='M-11109.5-16189.5l-10,10,10,10' transform='translate(11120.5 16190.914)' /></svg>
                <i className='hide'>다음</i>
              </span>
            </span>
          </button>
        )}

        {/* ...하단 버튼  */}
        <div className='mvs_paging_w'>
          <div className='mvs_paging_inner'>
            <ul className='mvsp_list_w'>
              {sliderPages > 1 ? (bigPaginationIndicator(sliderPages)) : ''}
            </ul>
            <>
              {sliderPages > 1 ? (bigPaginationAutoButton()) : ''}
            </>
          </div>
        </div>

      </div>
    </SliderContext.Provider>
  );
}
const forwardedRefInput = React.forwardRef(Jumbotron);
export default forwardedRefInput;
